import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/base/baseCurrency/page',
    method: 'get',
    params
  })
}

export function getDefaultCurrency() {
  return request({
    url: '/api/base/baseCurrency/default',
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: '/api/base/baseCurrency',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/base/baseCurrency',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/base/baseCurrency/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/base/baseCurrency',
    method: 'get',
    params: {
      id
    }
  })
}

export function listOption() {
  return request({
    url: '/api/base/baseCurrency/listOption',
    method: 'get'
  })
}
